module.exports = __webpack_public_path__ + "img/figure-14.ff8ab3c7.png";